import {
    ADD_TO_BASKET_STARTED,
    ADD_TO_BASKET_SUCCESS,
    ADD_TO_BASKET_FAILURE
  } from '../constants/auth.constant';
  
  const initialState = {
    loading: false,
    addToBasketInfo: {},
    error: null
  };
  
  export default function addToBasketReducer(state = initialState, action) {
    switch (action.type) {
      case ADD_TO_BASKET_STARTED:
        return {
          ...state,
          loading: true
        };
      case ADD_TO_BASKET_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          addToBasketInfo: action.payload
        };
      case ADD_TO_BASKET_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error
        };
      default:
        return state;
    }
  }